import React, {useState} from 'react';
import {Button, Divider, MenuItem, TextField, ThemeProvider, Tooltip} from "@mui/material";
import {THEME} from "../../theme/PacsTheme";
import FileUploadModal from "../../modals/file-upload/FileUploadModal";

import "./PresentationForm.css";
import {net_registrationValidate} from "../../net/RegistrationCalls";
import {net_createAbstractSubmission} from "../../net/AbstractCalls";
import {isNotNull} from "../../util/Validators";

import CloseIcon from '@mui/icons-material/Close';

import FileImage from "../../images/file-icon.svg";
import {net_removeFile} from "../../net/FileUploadCalls";

export default function PresentationForm(props) {

    const MAX_LENGTH = 500;

    const [disabled, setDisabled] = useState(true);
    const [formOpen, setFormOpen] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [data, setData] = React.useState({
        title: "",
        type: "",
        details: "",
        files: []
    });

    const [errors, setErrors] = React.useState({
        title: false,
        type: false,
        details: false
    });

    const [registration, setRegistration] = React.useState({
        data: null,
        error: false
    });

    const handleSubmitEmail = () => {

        net_registrationValidate(email, (response) => {
            if (response.code === 200) {
                setDisabled(false);
                setRegistration({...registration, data: response.registration, error: false});
            } else {
                setRegistration( {...registration, data: null, error: true});
            }
        }, error => {
            console.warn(error.message);
        })
    }

    const handleLargeField = (obj) => {

        if (obj.target.value.length <= MAX_LENGTH) {
            setData({...data, details: obj.target.value});
        }
    }

    const handleAddFile = () => {

        setFormOpen(true);
    }

    const handleSelect = (obj) => {
        setData({...data, type: obj.target.value});
    }

    const handleEmailAddress = (obj) => {
        setEmail(obj.target.value);
    }

    const hasErrors = (values) => {
        const keys = Object.keys(values);
        let has = false;

        keys.forEach((key) => {
            if (values[key]) {
                has = true;
            }
        })

        return has;
    }

    const hasError = (key) => {
        const copy = {...errors};

        copy[key] = data[key].length === 0;
        setErrors(copy);
    }

    const handleSubmit = () => {

        const payload = {
            title: data.title,
            type: data.type,
            details: data.details,
            presenterEmail: email,
            documents: data.files
        };

        const copy = {...errors};

        copy.title = payload.title.length === 0;
        copy.type = payload.type.length === 0;
        copy.details = payload.details.length === 0;

        if (hasErrors(copy)) {
            setErrors(copy);
        } else {
            net_createAbstractSubmission(payload, (response) => {
                if (response.code === 200) {
                    props.onComplete();
                } else {
                    alert("There was an error processing submission.");
                }
            }, error => {
                alert("Failed to submit abstract proposal.  Reason: " + error.message);
            })
        }
    }

    const handleUpload = (result) => {

        const copy = {...data};

        if (!copy.files.includes(result.name)) {
            copy.files.push(result.name);
        }

        setFormOpen(false);
        setData(copy);
    }

    const showMaxChars = (name, len) => {

        if (isNotNull(name)) {

            if (name.length < len) {
                return name.toLowerCase();
            }

            const extension = name.substring(name.lastIndexOf(".") + 1);
            const max = len - extension.length;

            return (name.substring(0, max) + "...." + extension).toLowerCase();
        }

        return "";
    }

    const removeFile = (file) => {

        const copy = {...data};
        const files = [];

        for (let i = 0; i < copy.files.length; i++) {
            if (copy.files[i].toLowerCase() !== file.toLowerCase()) {
                files.push(copy.files[i]);
            }
        }

        const payload = {
            file: file,
            id: registration.data.id
        }

        net_removeFile(payload, (response) => {
            if (response.code !== 200) {
                alert("Failed to remove file");
            } else {
                copy.files = files;

                setData(copy);
            }
        }, error => {
            console.warn(error.message);
        })
    }

    const buildFileObject = (file, idx) => {

        return <React.Fragment key={"fi"+idx}>
                <Tooltip title={file}>
                    <div style={{
                    border: "solid 1px #DDD",
                    marginRight: "5px",
                    marginLeft: "5px",
                    maxHeight: "80px",
                    maxWidth: "80px",
                    minWidth: "80px",
                    borderRadius: "15px"
                }}>
                    <div style={{
                        textAlign: "right",
                        margin: 0
                    }}>
                        <CloseIcon
                            color={"secondary"} style={{
                                transform: "scale(.6)",
                            }}
                            onClick={() => removeFile(file)}
                            className={"default-cursor-hover"}
                        />
                    </div>
                    <div style={{
                        position: "relative",
                        top: "-5px"
                    }}>
                        <img src={FileImage} width={32} alt={"file"}/>
                    </div>
                    <div style={{color: "black", position: "relative", top: "-5px", fontSize: "10px"}}>
                        {showMaxChars(file,12)}
                    </div>
                </div>
            </Tooltip>
        </React.Fragment>
    }

    const buildFileScroller = () => {

        return <React.Fragment>

            {data.files.map((file, idx) => {
                return buildFileObject(file, idx)
            })}

        </React.Fragment>
    }

    const handleChange = (obj) => {
        // only title here
        setData({...data, title: obj.target.value});
    }

    const registrationId = isNotNull(registration) && isNotNull(registration.data) ? registration.data.id : -1;

    return (<React.Fragment>

        <div
            style={{
                maxWidth: "800px",
                margin: "20px"
            }}
        >
            <div
                style={{
                    display: registration.data === null ? "block" : "none",
                }}
            >
                <div
                    style={{
                        color: "black",
                        marginBottom: "10px",
                    }}
                    className={"presentation-form-email-text"}
                >
                    Enter a registered email address to continue
                </div>

                <div>
                    <TextField
                        variant="outlined"
                        fullWidth
                        value={email}
                        label={"Registered Email Address"}
                        style={{
                            marginBottom: "5px"
                        }}
                        onChange={handleEmailAddress}
                    />
                </div>
                <div style={{
                    color: "red",
                    fontSize: "10px",
                    display: registration.error ? "block" : "none"
                }}>
                    Email address is not registered. Please register to continue.
                </div>

                <div style={{
                    marginTop: "10px"
                }}>
                    <ThemeProvider theme={THEME}>
                        <Button
                            variant={"contained"}
                            onClick={handleSubmitEmail}
                        >
                            <span>SUBMIT</span>
                        </Button>
                    </ThemeProvider>
                </div>
            </div>

            <div
                style={{
                    display: disabled ? "none" : "block"
                }}
            >
                <div
                    style={{
                        paddingBottom: "20px"
                    }}
                    className={"default-text-align-center default-font-color-dark default-font-bold default-font-xxlarge"}
                >
                    Abstract Details
                </div>
                <div className={"default-display-flex"}>
                    <div
                        className={"default-flex-size presentation-form-padding"}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label={"Title"}
                            disabled={disabled}
                            error={errors.title}
                            helperText={errors.title ? "Title is a required value" :""}
                            onBlur={() => hasError("title")}
                            onChange={handleChange}
                        />
                    </div>
                    <div
                        style={{
                            paddingLeft: "10px"
                        }}
                        className={"default-flex-size presentation-form-select"}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label={"Type"}
                            select
                            onChange={handleSelect}
                            name={"type"}
                            value={data.type}
                            style={{
                                textAlign: "left"
                            }}
                            disabled={disabled}
                            error={errors.type}
                            helperText={errors.type ? "Required value" :""}
                        >
                            <MenuItem value={"poster"}>Poster</MenuItem>
                            <MenuItem value={"speaker"}>Speaker</MenuItem>
                        </TextField>
                    </div>
                </div>
                <div className={"default-margin-top-large"}>
                    <TextField
                        variant="outlined"
                        rows={10}
                        multiline={true}
                        fullWidth
                        label={"Abstract Details"}
                        onChange={handleLargeField}
                        name={"details"}
                        value={data.details}
                        disabled={disabled}
                        error={errors.details}
                        helperText={errors.details ? "Details is a required value" :""}
                        onBlur={() => hasError("details")}
                    />
                </div>
                <div
                    style={{
                        textAlign: "right"
                    }}
                    className={"default-font-color-dark default-margin-top-tiny default-font-bold default-font-small"}
                >
                    {data.details.length}/{MAX_LENGTH}
                </div>
                <div className={"default-margin-top-large"}>
                    <Divider/>
                </div>
                <div className={"default-margin-top-large"}>
                    <div
                        style={{
                            display: "flex",
                            minHeight: "100px",
                            border: "1px solid #AAA",
                            borderRadius: "5px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            justifyContent: "center",
                            alignContent: "center",
                            alignItems: "center",
                            color: "#AAA"
                        }}
                        className={"default-margin-top-medium"}
                    >
                        {data.files.length === 0 ? "No Files Submitted" : buildFileScroller()}
                    </div>
                    <div
                        className={"default-margin-top-large"}
                        style={{
                            textAlign: "right",
                        }}
                    >
                        <ThemeProvider theme={THEME}>
                            <Button
                                variant={"contained"}
                                onClick={handleAddFile}
                                disabled={disabled}
                            >
                                <span>ADD FILE/DOCUMENT</span>
                            </Button>
                        </ThemeProvider>
                    </div>
                </div>
                <div className={"default-margin-top-large"}>
                    <Divider/>
                </div>
                <div
                    style={{
                        textAlign: "right",
                    }}
                    className={"default-margin-top-large"}
                >
                    <ThemeProvider theme={THEME}>
                        <Button
                            disabled={disabled}
                            variant={"contained"}
                            onClick={handleSubmit}
                        >
                            <span>SUBMIT</span>
                        </Button>
                    </ThemeProvider>
                </div>

                <FileUploadModal
                    key={"fum_"+Date.now()}
                    open={formOpen}
                    setOpen={setFormOpen}
                    id={registrationId}
                    onUpload={handleUpload}
                />
            </div>
        </div>

    </React.Fragment>)
}